'use strict';

import RapidMove from './rapidmove';

class JogY extends RapidMove {
    constructor(y: number | null = null) {
        super(null, y, null, null);
    }
}

export default JogY;
